/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EventDeviceRoomHouseResponseDto } from './EventDeviceRoomHouseResponseDto';
export type EventDeviceRoomResponseDto = {
  /**
   * Unique identifier of the room.
   */
  id?: number;
  /**
   * Name of the room (enum value).
   */
  name?: EventDeviceRoomResponseDto.name;
  /**
   * Custom name of the room, if set.
   */
  customName?: string;
  /**
   * House information of the room.
   */
  house?: EventDeviceRoomHouseResponseDto;
};
export namespace EventDeviceRoomResponseDto {
  /**
   * Name of the room (enum value).
   */
  export enum name {
    LIVING_ROOM = 'LIVING_ROOM',
    BEDROOM = 'BEDROOM',
    KITCHEN = 'KITCHEN',
    BATHROOM = 'BATHROOM',
    CHILDS_ROOM = 'CHILDS_ROOM',
    GARAGE = 'GARAGE',
    SUMMER_HOUSE = 'SUMMER_HOUSE',
    OTHER = 'OTHER',
  }
}

